"use strict";
import 'simplelightbox/dist/simple-lightbox.css';
import './../../sass/actions.sass';
import SimpleLightbox from "simplelightbox";
document.addEventListener('DOMContentLoaded', () => {
    new SimpleLightbox('.fn_gallery a', {
        disableRightClick: true, // Zabraňuje stahování obrázků
        alertError: true, // Ukáže upozornění při chybě načítání obrázku
        alertErrorMessage: 'Obrázek nebyl nalezen, načítám další obrázek.', // Custom chybová hláška
        captions: true, // Zobrazí popisek obrázku
        captionSelector: 'self', // Získá popisek z a href tagu
        captionType: 'attr',
        captionsData: 'title', // Můžeš také použít 'alt' nebo 'data-title'
        captionPosition: 'bottom'
    });
});
